export default (item) => ({
  design: '1',
  savings: 'PERCENT_OFF',
  durationUnit: item.periodUnit,
  quantityUnit: item.quantityOptions ? item.quantityUnitLabelKey?.replace('(s)', '').toUpperCase() || 'PLAN' : null
});
